import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SettlementService } from 'src/app/services/settlement.service';
import { SnackbarComponent } from '../snackbar/snackbar.component';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-create-group',
  templateUrl: './create-group.component.html',
  styleUrls: ['./create-group.component.scss']
})
export class CreateGroupComponent implements OnInit,OnDestroy {
  groupName: FormControl;
  actions: any[];
  loader: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<CreateGroupComponent>,
    private settlementService: SettlementService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.groupName = new FormControl('', [
      Validators.required
    ]);

    this.actions = [
      { text: "Cancel", buttonStyle: "underline", buttonSize: "action" },
      { text: this.data.settlement ? "Confirm" : "Save", spin: this.loader, buttonSize: "action" },
    ];
    if(this.data.settlement){
      this.groupName.setValue(this.data.settlement.name);
    }
  }

  action(event) {
    if (event === "Save" || event === "Confirm") {
      this.loader = true;
      let payload: any = {
        settlementGroupId: event === "Save" ? 0 : this.data.settlement.settlementGroupId,
        name: this.groupName.value
      }
      this.settlementService.SaveGroup(payload).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res) => {
        this.loader = false;
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: `Group ${event === "Save" ? 'added' : 'edited'}  successfully.`,
            action: 'Dismiss',
            type: 'info',
          },
        });
        this.dialogRef.close(event);
      },
         error: (err) => {
          this.loader = false;
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: err.error.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          });
          this.dialogRef.close();
         }
       });
    } else {
      this.dialogRef.close();
    }
  }

  close() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}